import { Expose } from 'class-transformer';
import { Model } from './model';

export class RateLookUp extends Model {
  @Expose() lookupName: string;
  @Expose() lookupId: string;
  @Expose() reviewerComment: string;
  @Expose() rate: number;
}
